import { render, staticRenderFns } from "./type2Detail.vue?vue&type=template&id=4eb30291&scoped=true"
import script from "./type2Detail.vue?vue&type=script&lang=js"
export * from "./type2Detail.vue?vue&type=script&lang=js"
import style0 from "./type2Detail.vue?vue&type=style&index=0&id=4eb30291&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb30291",
  null
  
)

export default component.exports